export const LIGHT_LOGO_URL = "/assets/images/logo/light-logo.png";
export const DARK_LOGO_URL = "/assets/images/logo/dark-logo.png";

// roles offered on the login page
export const USER_ROLES = [
  { role_code: 1001, role: "Admin", isSelected:true },
  { role_code: 1003, role: "Supplier", isSelected:false },
];

export const Admin_Code=1001;
export const Supplier__Code=1003;

export const COMP_INFO = {
  NAME: "Supplier Panel",
  TAGLINE: "Come Fly With Us",
  COUNTRY_CODE: "91",
  PHONE1: "9876543210",
  PHONE2: "8976543210",
  HELPLINE1: "1800-234-231",
  HELPLINE2: "1800-322-113",
  EMAIL: "companyemail@gmail.com",
  ADDRESS: "Ruchi Vihar, Vasant Kunj, New Delhi, Delhi 110070",
};

// ===== Theme: edit these values to restyle the whole app =====
export const THEME = {
  // top header bar
  // palette follows the agent front panel: #0E6A96 blue top strip and buttons, light blue nav bar
  HEADER_BG: "#ffffff",
  HEADER_TEXT: "#0f2a3d",
  // left menu
  MENU_BG: "#eaf4fa",
  MENU_TEXT: "#1e3a4c",
  MENU_ACTIVE_BG: "#0E6A96",
  MENU_ACTIVE_TEXT: "#ffffff",
  MENU_HOVER_BG: "#d6e9f5",
  MENU_HOVER_TEXT: "#0E6A96",
  // buttons
  BUTTON_BG: "#0E6A96",
  BUTTON_TEXT: "#ffffff",
  BUTTON_HOVER_BG: "#0A5478",
  // secondary (outline) buttons, e.g. "Download Sample CSV"
  SECONDARY_BUTTON_BG: "#ffffff",
  SECONDARY_BUTTON_TEXT: "#0E6A96",
  SECONDARY_BUTTON_BORDER: "#0E6A96",
  // tabs (selected and normal)
  TAB_ACTIVE_BG: "#0E6A96",
  TAB_ACTIVE_TEXT: "#ffffff",
  TAB_TEXT: "#374151",
  // list pages: table header, page heading, pagination
  TABLE_HEADER_BG: "#0E6A96",
  TABLE_HEADER_TEXT: "#ffffff",
  PAGE_HEADING_TEXT: "#0E6A96",
  PAGINATION_ACTIVE_BG: "#0E6A96",
  PAGINATION_ACTIVE_TEXT: "#ffffff",
  // font used everywhere (load it in public/index.html if it is a Google font)
  FONT_FAMILY: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif',
};

// ===== Row action buttons (view / edit / delete / star): icon class, colours and size =====
export const ACTION_ICONS = {
  view: "bi-eye-fill",
  edit: "bi-pencil-fill",
  delete: "bi-trash-fill",
  star: "bi-star-fill",
};

export const ACTION_BUTTON = {
  SIZE: 30, // button width/height in px
  ICON_SIZE: 14, // icon font size in px
  RADIUS: 8,
  view: { BG: "#d1fae5", TEXT: "#047857" },
  edit: { BG: "#dbeafe", TEXT: "#1d4ed8" },
  delete: { BG: "#fee2e2", TEXT: "#b91c1c" },
  star: { BG: "#fef3c7", TEXT: "#b45309" },
};

// ===== Role-based show/hide: list the role_codes (see USER_ROLES) that may see each item =====
// Edit the arrays to change what each role sees. An empty array hides the item for everyone.
export const ROLE_VISIBILITY = {
  // header bell icon
  header: {
    bellShake: [1003], // bell shakes while there are unread notifications
    bellLatestList: [1003], // dropdown with the latest notifications
    bellClickRedirect: [1001], // clicking the bell goes straight to /notifications
    walletBalance: [1003], // wallet balance pill (className="wallet-balance")
  },
  // /flight-search page
  flightSearchPage: {
    bookNowButton: [1003], // "Book Now" button on each result card
  },
  // /inventory/list page
  inventoryListPage: {
    addButton: [1003], // "Add Inventory"
    fareEditAction: [1003], // edit icon in the Fare column
    seatColumn: [1003], // the whole "+/- Seat" column
    rowEditDeleteActions: [1003], // edit / refresh / delete icons in the Action column
    rowViewAction: [1001], // eye icon in the Action column (opens fare details)
  },
  // /wallet page
  walletPage: {
    raiseRequestButton: [1003], // "Raise Wallet Request" (hidden for admin 1001)
    reviewActions: [1001], // Accept / Reject buttons in the Action column (supplier 1003 only gets View)
    adminFilters: [1001], // wallet_type, agent_code, supplier_code, payer_supplier_code, direction, request_type filters
  },
  // /notifications page
  notificationsPage: {
    addButton: [1003], // "Add Notification"
    markAllReadButton: [1003], // "Mark All as Read"
    markReadAction: [1003], // per-row "mark as read" icon button
  },
};

// finds the logged-in user's role_code from the auth state (user_info.role_code, or the role name)
export const resolveRoleCode = (authState: any): number | null => {
  const direct = authState?.user?.role_code ?? authState?.user_role?.role_code;
  if (direct !== undefined && direct !== null) return Number(direct);
  const roleName = String(
    authState?.user_role?.role ?? authState?.user_role ?? "",
  ).toLowerCase();
  return (
    USER_ROLES.find((r) => r.role.toLowerCase() === roleName)?.role_code ?? null
  );
};

export const isVisibleForRole = (roles: number[], authState: any): boolean => {
  const code = resolveRoleCode(authState);
  return code !== null && roles.includes(code);
};

export const checkIsAdmin = (userRole: any): boolean => {
  return userRole?.code === 1001 && userRole.role_type.toLowerCase()==='admin';
};